export interface UsuarioConRestriccionInput {
  id?: number | string | null;
  tipo_usuario?: string | null;
  id_empleado?: number | string | null;
}

export interface EmpleadoConRestriccionInput {
  id?: number | string | null;
  cargo?: string | null;
}

export interface MedicoConRestriccionInput {
  id?: number | string | null;
  id_usuario?: number | string | null;
}

export interface RestriccionUsuarioMedicoResultado {
  esUsuarioMedicoRestringido: boolean;
  medicoPropioId: number | null;
}

function normalizarTexto(value: unknown): string {
  return String(value ?? '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .trim()
    .toUpperCase();
}

export function resolverRestriccionUsuarioMedicoContexto(params: {
  currentUserId: number | null | undefined;
  rol: string | null | undefined;
  esAdministrador: boolean;
  medicos: MedicoConRestriccionInput[];
  usuarios: UsuarioConRestriccionInput[];
  empleados: EmpleadoConRestriccionInput[];
}): RestriccionUsuarioMedicoResultado {
  const currentUserId = Number(params.currentUserId ?? 0);
  if (params.esAdministrador || !currentUserId) {
    return { esUsuarioMedicoRestringido: false, medicoPropioId: null };
  }

  const usuarios = params.usuarios || [];
  const medicos = params.medicos || [];
  const empleados = params.empleados || [];

  const usuarioActual = usuarios.find((u) => Number((u as any)?.id) === currentUserId) || null;
  const medicoActual = medicos.find((m) => Number((m as any)?.id_usuario) === currentUserId) || null;
  const empleadoActual = usuarioActual && (usuarioActual as any)?.id_empleado != null
    ? empleados.find((e) => Number((e as any)?.id) === Number((usuarioActual as any)?.id_empleado)) || null
    : null;

  const tipoUsuario = normalizarTexto((usuarioActual as any)?.tipo_usuario);
  const cargo = normalizarTexto((empleadoActual as any)?.cargo);
  const rol = normalizarTexto(params.rol);

  const esCargoMedico = cargo === 'MEDICO GENERAL' || cargo === 'MEDICO ESPECIALISTA';
  const esUsuarioMedico = tipoUsuario === 'MEDICO_INTERNO' || tipoUsuario === 'MEDICO_EXTERNO';
  const esRolMedico = rol.includes('MEDICO');
  const esMedicoVinculado = !!medicoActual;

  return {
    esUsuarioMedicoRestringido: esMedicoVinculado || esUsuarioMedico || esCargoMedico || esRolMedico,
    medicoPropioId: medicoActual ? Number((medicoActual as any)?.id) : null,
  };
}
